import { observer } from 'mobx-react-lite'
import { useStore } from '../../../contexts/store'
import { PodClass } from '../../../classes/Pod'
import Badge, { BadgeProps } from '@mui/material/Badge'
import { styled } from '@mui/material/styles'

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    borderRadius: "5px",
  },
}))

const ConversationUnreads = () => {
  const { sessionStore, podStore } = useStore()
  const pod:PodClass|null = podStore.pod
  if (!sessionStore.session) return null
  const userId = sessionStore.session.user.userId
  let unreads = 0

  // load list of conversations in which the user is involved
  const conversationList = podStore.getConversations(userId)
  if(pod === null || conversationList === null) return null

  for(const conversation of conversationList) {
    if(conversation.hasUnreadMessages) unreads++
  }

  if(unreads === 0) return null
  return (
    <StyledBadge badgeContent={unreads} color="secondary" sx={{margin: "0 20px"}} />
  )
}

export default observer(ConversationUnreads)